/*
Phone format library was massive so we replaced it with this function
that specifically formats only 10 digit phone numbers
*/
let phoneformat = (phone) => {
  if (!phone) {
    return phone;
  }
  phone = phone.toString().replace(/\D/g, '');
  if (phone.length !== 10) {
    return phone;
  }
  return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
};

export default phoneformat;
